"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authStates = exports.AuthEvents = exports.AuthCredentialsEnum = exports.AuthStateEnum = void 0;
var AuthStateEnum;
(function (AuthStateEnum) {
    AuthStateEnum["IDLE"] = "IDLE";
    AuthStateEnum["TECHNICAL_ERROR"] = "TECHNICAL_ERROR";
    AuthStateEnum["CREDENTIALS_REQUIRED"] = "CREDENTIALS_REQUIRED";
    AuthStateEnum["AUTHENTICATION_COMPLETED"] = "AUTHENTICATION_COMPLETED";
    AuthStateEnum["AUTHENTICATION_FAILED"] = "AUTHENTICATION_FAILED";
    AuthStateEnum["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    AuthStateEnum["USER_LOGGED_OUT"] = "USER_LOGGED_OUT";
    AuthStateEnum["LOGOUT_FAILED"] = "LOGOUT_FAILED";
})(AuthStateEnum || (exports.AuthStateEnum = AuthStateEnum = {}));
var AuthCredentialsEnum;
(function (AuthCredentialsEnum) {
    AuthCredentialsEnum["USER"] = "user";
    AuthCredentialsEnum["PASSWORD"] = "password";
    AuthCredentialsEnum["CHALLENGE"] = "challenge";
})(AuthCredentialsEnum || (exports.AuthCredentialsEnum = AuthCredentialsEnum = {}));
var AuthEvents;
(function (AuthEvents) {
    AuthEvents["IDLE"] = "IDLE";
    AuthEvents["INITIATE"] = "INITIATE";
    AuthEvents["VALIDATE"] = "VALIDATE";
    AuthEvents["LOGOUT"] = "LOGOUT";
})(AuthEvents || (exports.AuthEvents = AuthEvents = {}));
exports.authStates = {
    [AuthStateEnum.IDLE]: {
        transitions: [
            AuthStateEnum.AUTHENTICATION_COMPLETED,
            AuthStateEnum.AUTHENTICATION_FAILED,
            AuthStateEnum.INVALID_CREDENTIALS,
            AuthStateEnum.CREDENTIALS_REQUIRED,
            AuthStateEnum.TECHNICAL_ERROR,
        ],
    },
    [AuthStateEnum.CREDENTIALS_REQUIRED]: {
        transitions: [
            AuthStateEnum.AUTHENTICATION_COMPLETED,
            AuthStateEnum.AUTHENTICATION_FAILED,
            AuthStateEnum.INVALID_CREDENTIALS,
            AuthStateEnum.CREDENTIALS_REQUIRED,
            AuthStateEnum.TECHNICAL_ERROR,
        ],
    },
    [AuthStateEnum.AUTHENTICATION_COMPLETED]: {
        transitions: [AuthStateEnum.USER_LOGGED_OUT, AuthStateEnum.LOGOUT_FAILED, AuthStateEnum.TECHNICAL_ERROR],
    },
    [AuthStateEnum.AUTHENTICATION_FAILED]: {
        transitions: [AuthStateEnum.TECHNICAL_ERROR],
    },
    [AuthStateEnum.INVALID_CREDENTIALS]: {
        transitions: [
            AuthStateEnum.AUTHENTICATION_COMPLETED,
            AuthStateEnum.AUTHENTICATION_FAILED,
            AuthStateEnum.CREDENTIALS_REQUIRED,
            AuthStateEnum.INVALID_CREDENTIALS,
            AuthStateEnum.TECHNICAL_ERROR,
        ],
    },
    [AuthStateEnum.USER_LOGGED_OUT]: {
        transitions: [AuthStateEnum.CREDENTIALS_REQUIRED],
    },
    [AuthStateEnum.LOGOUT_FAILED]: {
        transitions: [AuthStateEnum.CREDENTIALS_REQUIRED],
    },
    [AuthStateEnum.TECHNICAL_ERROR]: {
        transitions: [AuthStateEnum.CREDENTIALS_REQUIRED],
    },
};
//# sourceMappingURL=auth.types.js.map